import CryptoJs from 'crypto-js';

const cryptoKey = process.env.REACT_APP_PASS_PHRASE ?? '';

export const getAuthToken = (): string | null => {
    const auth = localStorage.getItem('auth');
    if (!auth) return null;
    try {
        const data = JSON.parse(
            CryptoJs.AES.decrypt(auth, cryptoKey.toString()).toString(CryptoJs.enc.Utf8)
        );
        return data.authorization ?? null;
    } catch {
        return null;
    }
};
